import React, { useEffect, useState } from "react";
import Create from "../components/Banners/Create";
import View from "../components/Banners/View";
import Edit from "../components/Banners/Edit";
import { Header } from "../components";
import api from "../api/api";
import { CircularProgress } from "@mui/material";
import Alerts from "../components/Alerts";

const CreateBanner = () => {
  const [option, setOption] = useState("view");
  const [banners, setBanners] = useState(null);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});

  useEffect(() => {
    api.get("/banners/body").then((response) => {
      setBanners(response.data);
      console.log(response.data);
    });
  }, [option]);

  const handleDeleteBanner = (id) => {
    api
      .delete(`/banners/body/${id}`)
      .then((response) => {
        console.log(response.data);

        // Atualiza a lista local removendo o banner deletado
        setBanners((prevBanners) => prevBanners.filter((b) => b.id !== id));

        setOpenSnackbar(true);
        setWarning({
          type: "success",
          message: "Banner deletado com sucesso.",
        });
      })
      .catch((error) => {
        console.error("Erro ao deletar banner", error);
        setOpenSnackbar(true);
        setWarning({
          type: "error",
          message: "Erro ao deletar banner.",
        });
      });
  };

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      {option === "create" ? (
        <>
          <Header category="Home Page" title="Novo Banner" />
          <Create setOption={setOption} />
        </>
      ) : option === "edit" && selectedBanner ? ( // Garantir que selectedBanner não é nulo
        <>
          <Header category="Home Page" title="Editar Banner" />
          <Edit selectedBanner={selectedBanner} setOption={setOption} />
        </>
      ) : banners ? (
        <>
          <Header category="Home Page" title="Banners 2" />
          <View
            banners={banners}
            setOption={setOption}
            setSelectedBanner={setSelectedBanner}
            handleDeleteBanner={handleDeleteBanner}
            handleOpenSnackbar={handleOpenSnackbar}
            handleCloseSnackbar={handleCloseSnackbar}
            warning={warning}
            openSnackbar={openSnackbar}
          />
        </>
      ) : (
        <>
          <Header category="Home Page" title="Banners" />
          <div className="flex items-center justify-center h-40">
            <CircularProgress />
          </div>
        </>
      )}
      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default CreateBanner;
